module.exports = __webpack_public_path__ + "img/back-inactive.7abbbd5d.svg";